import $ from 'jquery';
import datepicker from 'jquery-ui';
import config from '../app-config';

function setDatepicker() {
    $( ".datepicker__field" ).datepicker({
        showOtherMonths: true,
    });
}

function setRange(onChange) {
    $( "#date-start" ).datepicker({
        defaultDate: "+1w",
        changeMonth: true,
        numberOfMonths: 1,
        showOtherMonths: true,
        dateFormat: 'dd.mm.yy',
        onSelect: function() {
            if (typeof onChange === 'function') {
                onChange();
            }
        },
        onClose: function( selectedDate ) {
            $( "#date-end" ).datepicker( "option", "minDate", selectedDate );
        }
    });
    $( "#date-end" ).datepicker({
        defaultDate: "+1w",
        changeMonth: true,
        numberOfMonths: 1,
        showOtherMonths: true,
        dateFormat: 'dd.mm.yy',
        onSelect: function() {
            if (typeof onChange === 'function') {
                onChange();
            }
        },
        onClose: function( selectedDate ) {
            $( "#date-start" ).datepicker( "option", "maxDate", selectedDate );
        }
    });
}

function init() {
    if ($('.datepicker').length > 0) setDatepicker();
    if ($('.datepicker.-range').length > 0) setRange();
}

export { init, setRange };


// WEBPACK FOOTER //
// ./src/_app/layout/datepicker.js